import { createVNode as _createVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/eye.svg'
import _imports_1 from '@/app/ui/assets/svg/invisible.svg'
import _imports_2 from '@/app/ui/assets/svg/exclamation-triangle.svg'
import _imports_3 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'


const _hoisted_1 = {
  style: {"width":"60vw"},
  class: "relative edit-body overflow-y-auto"
}
const _hoisted_2 = { class: "inline-block relative w-full" }
const _hoisted_3 = /*#__PURE__*/_createVNode("input", {
  type: "text",
  autocomplete: "username",
  style: {"opacity":"0","position":"absolute","left":"-9999px"},
  tabindex: "-1"
}, null, -1)
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "h-6"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "h-6"
}
const _hoisted_6 = { class: "text-red-lp-100 flex gap-x-2 text-12px" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "warning"
}, null, -1)
const _hoisted_8 = { class: "inline-block relative w-full" }
const _hoisted_9 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "h-6"
}
const _hoisted_10 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "h-6"
}
const _hoisted_11 = {
  key: 0,
  class: "text-red-lp-100 flex gap-x-2 text-12px"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_13 = {
  key: 1,
  class: "text-red-lp-100 flex gap-x-2 text-12px"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "warning"
}, null, -1)
const _hoisted_15 = { class: "inline-block relative w-full" }
const _hoisted_16 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "h-6"
}
const _hoisted_17 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "h-6"
}
const _hoisted_18 = {
  key: 0,
  class: "text-red-lp-2000 mb-2 text-12px mt-1 xxl:text-14px flex pl-1 gap-x-2"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_20 = {
  key: 1,
  class: "text-red-lp-100 text-12px flex gap-x-2"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "warning"
}, null, -1)
const _hoisted_22 = { class: "bg-gray-lp-200 p-3 rounded-md mt-4" }
const _hoisted_23 = { class: "flex items-start gap-x-3" }
const _hoisted_24 = { class: "text-12px xxl:text-14px font-normal text-gray-lp-800" }
const _hoisted_25 = {
  key: 0,
  class: "text-sm text-red-lp-100 font-semibold bg-red-lp-1300 rounded-md px-5 py-2.5 text-center flex items-center gap-x-3 mt-4"
}
const _hoisted_26 = { class: "rounded-full bg-white p-2" }
const _hoisted_27 = { class: "rounded-full bg-red-lp-100 flex items-center justify-center p-1" }
const _hoisted_28 = { class: "flex justify-end mt-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_OtpDisclaimer = _resolveComponent("OtpDisclaimer")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    "model-value": _ctx.modelValue,
    persistent: true,
    title: _ctx.$t('Ubah Password'),
    "onUpdate:modelValue": _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('Password Lama'),
          class: "mb-6"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _hoisted_3,
              _withDirectives(_createVNode("input", {
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validateOldPassword && _ctx.validateOldPassword(...args))),
                type: _ctx.oldPasswordType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.oldPassword = $event)),
                autocomplete: "current-password",
                placeholder: _ctx.$t('Masukan password lama'),
                class: ["block appearance-none w-full bg-white border px-4 py-3 pr-8 my-2 rounded shadow leading-tight focus:outline-none", {
              'border-red-lp-700': _ctx.isWrongOldPassword,
              'border-2': !_ctx.isWrongOldPassword
            }]
              }, null, 42, ["type", "placeholder"]), [
                [_vModelDynamic, _ctx.oldPassword]
              ]),
              _createVNode("button", {
                type: "button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showOldPassword && _ctx.showOldPassword(...args))),
                class: "cursor-pointer absolute inset-y-0 right-0 flex items-center px-6 text-gray-500 focus:outline-none"
              }, [
                (_ctx.oldPasswordType === 'password')
                  ? (_openBlock(), _createBlock("img", _hoisted_4))
                  : (_openBlock(), _createBlock("img", _hoisted_5))
              ])
            ]),
            _withDirectives(_createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("Password lama Anda salah")), 1)
            ], 512), [
              [_vShow, _ctx.isWrongOldPassword]
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('Password Baru'),
          class: "mb-6"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_8, [
              _withDirectives(_createVNode("input", {
                type: _ctx.passwordType,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.newPassword = $event)),
                placeholder: _ctx.$t('Masukan password baru'),
                class: ["block appearance-none w-full bg-white border px-4 py-3 pr-8 my-2 rounded shadow leading-tight focus:outline-none", {
              'border border-red-lp-100': _ctx.newPasswordInvalid ||  (_ctx.oldPassword && _ctx.newPassword && _ctx.oldPassword === _ctx.newPassword),
              'border-2': !_ctx.newPasswordInvalid
            }],
                autocomplete: "new-password"
              }, null, 10, ["type", "placeholder"]), [
                [_vModelDynamic, _ctx.newPassword]
              ]),
              _createVNode("button", {
                type: "button",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showPassword && _ctx.showPassword(...args))),
                class: "cursor-pointer absolute inset-y-0 right-0 flex items-center px-6 text-gray-500 focus:outline-none"
              }, [
                (_ctx.passwordType === 'password')
                  ? (_openBlock(), _createBlock("img", _hoisted_9))
                  : (_openBlock(), _createBlock("img", _hoisted_10))
              ])
            ]),
            (_ctx.oldPassword && _ctx.newPassword && _ctx.oldPassword === _ctx.newPassword)
              ? (_openBlock(), _createBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode("span", null, _toDisplayString(_ctx.$t("profile.passwordOne")), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.newPasswordInvalid)
              ? (_openBlock(), _createBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createTextVNode(" " + _toDisplayString(_ctx.newPasswordInvalid), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('Konfirmasi Password Baru')
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_15, [
              _withDirectives(_createVNode("input", {
                type: _ctx.confirmationNewPasswordType,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirmationNewPassword = $event)),
                placeholder: _ctx.$t('Konfirmasi password baru'),
                class: ["block appearance-none w-full bg-white border px-4 py-3 pr-8 my-2 rounded shadow leading-tight focus:outline-none", {
              'border border-red-lp-100': _ctx.confirmationNewPasswordInvalid || (_ctx.oldPassword && _ctx.confirmationNewPassword && _ctx.oldPassword === _ctx.confirmationNewPassword),
              'border-2': !_ctx.confirmationNewPasswordInvalid
            }],
                autocomplete: "confirm-new-password"
              }, null, 10, ["type", "placeholder"]), [
                [_vModelDynamic, _ctx.confirmationNewPassword]
              ]),
              _createVNode("button", {
                type: "button",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.showConfirmationPassword && _ctx.showConfirmationPassword(...args))),
                class: "cursor-pointer absolute inset-y-0 right-0 flex items-center px-6 text-gray-500 focus:outline-none"
              }, [
                (_ctx.confirmationNewPasswordType === 'password')
                  ? (_openBlock(), _createBlock("img", _hoisted_16))
                  : (_openBlock(), _createBlock("img", _hoisted_17))
              ])
            ]),
            (_ctx.oldPassword && _ctx.confirmationNewPassword && _ctx.oldPassword === _ctx.confirmationNewPassword)
              ? (_openBlock(), _createBlock("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode("span", null, _toDisplayString(_ctx.$t("profile.passwordTwo")), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.confirmationNewPasswordInvalid)
              ? (_openBlock(), _createBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _createTextVNode(" " + _toDisplayString(_ctx.confirmationNewPasswordInvalid), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_OtpDisclaimer, {
          show: _ctx.FlagsOtp.otp_enable_change_password.isEnabled()
        }, null, 8, ["show"]),
        _createVNode("div", _hoisted_22, [
          _createVNode("div", _hoisted_23, [
            _createVNode("img", {
              src: require(`@/app/ui/assets/svg/info-red.svg`),
              class: "ml-2 w-5",
              alt: "warning"
            }, null, 8, ["src"]),
            _createVNode("div", _hoisted_24, _toDisplayString(_ctx.$t(
                "Setelah password berhasil terubah, gunakan password baru untuk Log In."
              )), 1)
          ])
        ]),
        (_ctx.errorMessageOtp)
          ? (_openBlock(), _createBlock("div", _hoisted_25, [
              _createVNode("div", _hoisted_26, [
                _createVNode("div", _hoisted_27, [
                  _createVNode(_component_Icons, {
                    name: "close",
                    class: "w-3 h-3 text-white"
                  })
                ])
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.errorMessageOtp), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_28, [
          _createVNode(_component_lp_button, {
            disabled: !_ctx.isFormValid,
            "text-color": "white",
            "custom-class": "px-10",
            onClick: _ctx.confirmationChangePassword,
            title: _ctx.$t('Simpan')
          }, null, 8, ["disabled", "onClick", "title"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title", "onUpdate:modelValue"]))
}